<script>
import { routeStartsWith } from '@/helpers/routes'

export default {
  name: 'sidemenu',
  computed: {
    isCurrentRoute () {
      return routeStartsWith(this.$route, this.prefixRoute)
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    route: {
      type: String,
      default: ''
    },
    prefixRoute: {
      type: String,
      default: ''
    },
    icon: null
  },
  mounted () {
  },
  created () {
    if (this.$store.getters.jwt.token !== null) {
      this.ed = this.$ws
      .withJwtToken(this.$store.getters.jwt.token.substr(7))
      .connect()
      .subscribe('notifications')
    }
  }
}
</script>


<template lang="pug">
  li(:class="{'sub-active': isCurrentRoute}")
    router-link(:to="{ name: route }", active-class="sub-active")
      span {{ icon }}
      a(href="#", :class="{'sub-active': isCurrentRoute}") {{ label }}
</template>



// WEBPACK FOOTER //
// src/layout/sidemenu.vue